<template>
    <div class="row">
      <div class="col-sm-6 order-2-xs">
        <div class="premium-title">
          {{$lang.messages.get_premium_modal.features.title}}
        </div>
        <div class="premium-feature flex" :key=feature.id v-for="feature in features">
          <div class="premium-feature-icon">
            <div :class="'icon-'+ feature.icon"></div>
          </div>
          <div class="premium-feature-content">
            <div class="premium-feature-title text-lg text-bold">{{feature.title}}</div>
            <div class="">
              <span class="premium-feature-text" :key=item.index v-for="item in feature.text">{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="content-block-item -get-premium">
          <div class="modal-title text-center mb-2" v-if="type === 'base'">{{$lang.messages.get_premium_modal.title}}</div>
          <div class="flex flex-wrap-xs" v-if="type === 'base'">
            <label class="radio-wrapper -premium flex-wrap" :class="{active: premiumPlan === 'month'}">
              <input name="premiumPlan" type="radio" class="radio-input" value="month" v-model="premiumPlan">
              <span class="radio-check"></span>
              <span class="radio-label">{{$lang.messages.get_premium_modal.monthly}}</span>
              <span class="w-100"><span class="text-lg text-bold">$2.99 </span><span class="text-sm">per month</span></span>
            </label>
            <label class="radio-wrapper -premium flex-wrap" :class="{active: premiumPlan === 'year'}">
              <input name="premiumPlan" type="radio" class="radio-input" value="year" v-model="premiumPlan">
              <span class="radio-check"></span>
              <span class="radio-label">{{$lang.messages.get_premium_modal.yearly}}</span>
              <span class="premium-sale">{{$lang.messages.get_premium_modal.save_20}}</span>
              <span class="w-100"><span class="text-lg text-bold">$2.41</span> <span class="text-sm">{{$lang.messages.get_premium_modal.per_month}}</span></span>
            </label>
          </div>
          <div class="flex flex-end" v-if="type === 'base'">
            <div class="flex">
              <svg width="52" height="25" viewBox="0 0 52 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M51 21C35.3333 26.1667 4 29.5 4 1.5M4 1.5L0.5 5.5M4 1.5L8 5.5" stroke="#9F81F8"/>
              </svg>
              <div class="premium-label-free">
                <div class="text-thin">{{$lang.messages.get_premium_modal.get}}</div>
                {{$lang.messages.get_premium_modal.two_month_free}}
                </div>
            </div>
          </div>
          <div class="premium-total">
            <div v-if="type === 'trial'" class="w-100">
                <div class="text-lg text-bold mb-1">
                  Subscription details
                </div>
              <div class="w-100 flex-v-center flex-between text-md mb-05">
                Yearly subscription
                <div class="text-bold text-lg">
                  $29
                </div>
              </div>
              <div class="w-100 flex-v-center flex-between text-md mb-05">
                Tax
                <div class="text-bold text-lg">
                  $0
                </div>
              </div>
              <div class="w-100 flex-between text-md mb-05">
                <div>
                  Total billed {{trialEndDate}}
                  <div class="premium-trial-label">
                    We will remind you 2 days before your trial period ends
                  </div>
                </div>
                <div class="text-bold text-lg">
                  $29
                </div>
              </div>

              <div class="divider"></div>
            </div>
            <div class="premium-sale-total" v-if="premiumPlan !== 'month' && type === 'base'">{{$lang.messages.get_premium_modal.percent_off}}</div>
            <div class="w-100 flex-v-center flex-between text-bold">
              <div class="text-lg">{{$lang.messages.get_premium_modal.total}}</div>
              <div v-if="type === 'base'">{{ premiumPlan === 'month' ? '$2.99' : '$29' }}</div>
              <div v-if="type === 'trial'">
                $0
              </div>
            </div>
          </div>
          <div class="text-lg text-bold mb-1"> {{$lang.messages.get_premium_modal.billing_info}}</div>
          <Stripe :premiumPlan="premiumPlan" :customer="customer" :trial="type === 'trial'"
                  v-on:premiumispurchased = "premiumIsPurchased"
                  v-on:updatesettings = "updateSettings"/>
          <div class="premium-card-info">{{$lang.messages.get_premium_modal.card_text_info}}</div>
        </div>
      </div>
  </div>
</template>

<script>

import Stripe from "@/components/Stripe"
import { getTimeStamp, getMDY } from '../helpers/utils.js'
export default {
  name: 'GetPremiumForm',
  props: {
    customer: Object,
    type: {
      type: String,
      default: 'base'
    },
    initialPremiumPlan: String,

  },
  data: function () {
    return {
      premiumPlan: this.initialPremiumPlan || 'month',
      features: [
        {
          id: 0,
          title: this.$lang.messages.get_premium_modal.features.feture_1_title,
          icon: 'settings',
          text: this.$lang.messages.get_premium_modal.features.feture_1_texts
        },
        {
          id: 1,
          title: this.$lang.messages.get_premium_modal.features.feture_2_title,
          icon: 'themes',
          text: this.$lang.messages.get_premium_modal.features.feture_2_texts
        },
        {
          id: 2,
          title: this.$lang.messages.get_premium_modal.features.feture_3_title,
          icon: 'statistic',
          text: this.$lang.messages.get_premium_modal.features.feture_3_texts
        },
        {
          id: 3,
          title: this.$lang.messages.get_premium_modal.features.feture_4_title,
          icon: 'statistic',
          text: this.$lang.messages.get_premium_modal.features.feture_4_texts
        }
      ],
      trialEndDate: getMDY(new Date().getTime(), 7)
    }
  },
  methods: {
    premiumIsPurchased () {
      getTimeStamp((newTS) => {
        const today = new Date(newTS)
        let premiumEnd
        if(this.premiumPlan === 'month'){
          premiumEnd = today.setMonth(today.getMonth() + 1)
        } else {
          premiumEnd = today.setUTCFullYear(today.getUTCFullYear() + 1)
        }
        this.$emit('premiumispurchased');
        const newSet = {
          'premiumEnd': premiumEnd,
          'isPremium': true
        }
        this.updateSettings(newSet)
      })
    },
    updateSettings(settingsInObj){
      this.$emit('updatesettings', settingsInObj)
    }
  },
  components: {
    Stripe
  }
}

</script>
<style lang="scss">
@import "../assets/styles/helpers";

.radio-wrapper.-premium {
  border: 1px solid #B2B4CF;
  align-items: flex-start;

  .radio-label {
    margin-bottom: 5px;
  }

  .radio-check {
    margin-top: 2px;
  }

  .premium-sale {
    font-size: 12px;
    background-color: #9F81F8;
    border-radius: 3px;
    padding: 3px;
    color: #fff;
    display: inline-block;
    margin-left: auto;
  }
}

.premium-sale-total {
  color: #9F81F8;
  width: 100%;
  font-size: 12px;
  text-align: right;
  display: block;
  font-weight: 400;
  position: absolute;
  top: 10px;
  right: 30px;
}

.premium {
  &-title {
    font-size: 36px;
    margin-bottom: 50px;

    @include responsive-below($xs){
      margin-top: 30px;
      margin-bottom: 20px;
    }
  }

  &-feature {
    margin-bottom: 20px;

    &-icon {
      padding-top: 5px;
      margin-right: 20px;
    }

    &-text {
      font-weight: 600;
      color: #95959a;
      margin-right: 6px;

      &:before {
        content: "";
        display: inline-block;
        margin-right: 6px;
        width: 4px;
        height: 4px;
        background: #c4c4c4;
        border-radius: 50%;
        vertical-align: middle;
      }
    }
  }

  &-total {
    background: #FCFCFC;
    border-radius: 16px;
    padding: 24px 30px;
    font-size: 24px;
    margin: 14px 0 22px;
    position: relative;
  }

  &-card-info {
    color: #95959A;
    text-align: center;
    font-size: 12px;
    margin-top: 8px;
  }

  &-label-free {
    margin-left: 4px;
    font-size: 14px;
    line-height: 1;
    font-weight: 600;
    padding-top: 5px;
  }

  &-trial-label {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #95959a;
  }
}

.divider {
  border-top: 1px solid #F4F6F6;
  margin: 10px 0;
}

</style>
